module.exports = __webpack_public_path__ + "main/assets/public/button/up-arrow.c6cef31388204955.svg";